<template>
  <v-container class="mt-3 pa-0">
    <v-flex>
      <RmaDetails :rma="rma"></RmaDetails>
    </v-flex>
  </v-container>
</template>

<script>
import RmaDetails from "@/components/rma/RmaDetails";
import LoginCheck from "@/mixins/LoginCheck";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },

  mixins: [LoginCheck],

  async beforeMount() {
    this.getRma(this.$route.params.id);
  },

  computed: {
    ...mapGetters({
      rma: "rma/getRma"
    })
  },

  components: {
    RmaDetails
  },

  methods: {
    ...mapActions({
      getRma: "rma/loadOne"
    })
  }
};
</script>
